import loc from 'owa-localize';
import { selectSubcategory } from 'owa-options-orchestration';
import { getStore } from 'owa-options-store';
import { observer } from 'mobx-react-lite';
import { BaseButton } from 'office-ui-fabric-react/lib/Button';
import { OptionSubCategory } from 'owa-options-core';

import * as React from 'react';
import { AnimationClassNames } from '@uifabric/styling';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';

const styles = require('./OptionsFull.scss');
const className = require('classnames/bind').bind(styles);

interface OptionEntryProps {
    subcategory: OptionSubCategory;
}

export const SubCategoryEntry = observer(function SubCategoryEntry(props: OptionEntryProps) {
    let buttonStyles = {
        root: className(styles.option, {
            selectedOption: getStore().currentSubCategoryKey === props.subcategory.key,
        }),
        flexContainer: styles.optionFlexContainer,
        label: styles.optionLabel,
    };
    const onClick = React.useCallback(() => selectSubcategory(props.subcategory), [
        props.subcategory,
    ]);
    return (
        <BaseButton
            styles={buttonStyles}
            key={props.subcategory.key}
            onClick={onClick}
            text={loc(props.subcategory.titleStringKey) as string}
            role="tab"
        />
    );
});

export interface OptionsColumnProps {
    subcategories: OptionSubCategory[];
}
export const SubCategoriesColumn = observer(function SubCategoriesColumn(
    props: OptionsColumnProps
) {
    return (
        <div className={styles.optionsColumn} role="tablist">
            <FocusZone
                direction={FocusZoneDirection.vertical}
                key={getStore().currentCategoryKey}
                className={AnimationClassNames.slideLeftIn20}>
                {props.subcategories.map(subcategory => (
                    <SubCategoryEntry subcategory={subcategory} key={subcategory.key} />
                ))}
            </FocusZone>
        </div>
    );
});
